import { render, staticRenderFns } from "./browseList.vue?vue&type=template&id=4702c442"
import script from "./browseList.vue?vue&type=script&lang=js"
export * from "./browseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports